import * as React from "react";
import { CompanyDto } from "Api/Api";
import styled from "styled-components";
import { useResource, Resources } from "Translations/Resources";

type Props = {
  company: CompanyDto;
};

const StyledWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const StyledAddress = styled.div`
  margin-bottom: 10px;
`;

const StyledBasicInfo = styled.div``;

export const CompanyDetailAddress: React.FunctionComponent<Props> = props => {
  const { company } = props;
  const { t } = useResource();

  return (
    <>
      <StyledWrapper className={"row"}>
        <div className={"row-title"}>
          {t(Resources.Companies.Detail.Address)}
        </div>
        <div>
          <div>{company.name}</div>
          <StyledAddress>
            <div>{`${company.street} ${company.streetNo}`}</div>
            <div>{`${company.city} ${company.postalCode}`}</div>
          </StyledAddress>

          <StyledBasicInfo>
            <div>
              {`${t(Resources.Companies.Detail.IdentificationNumber)}: ${
                company.identificationNumber
              }`}
            </div>
            {company.taxIdentificationNumber && (
              <div>
                {`${t(Resources.Companies.Detail.TaxIdentificationNumber)}: ${
                  company.taxIdentificationNumber
                }`}
              </div>
            )}
          </StyledBasicInfo>
        </div>
      </StyledWrapper>
      <hr />
    </>
  );
};
